import dayjs from 'dayjs';

import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(utc);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);

export const DlDayJs = dayjs;
